import { render, staticRenderFns } from "./ChatText.vue?vue&type=template&id=f134e4e6&scoped=true"
import script from "./ChatText.vue?vue&type=script&lang=js"
export * from "./ChatText.vue?vue&type=script&lang=js"
import style0 from "./ChatText.vue?vue&type=style&index=0&id=f134e4e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f134e4e6",
  null
  
)

export default component.exports